import { createAction } from "@reduxjs/toolkit";
import { ApplicationState } from "state/application/reducer";

export const setError = createAction<ApplicationState["error"]>("application/setError");

export const setSuccess = createAction<ApplicationState["success"]>("application/setSuccess");
